module.exports = __webpack_public_path__ + "media/St 4-Question 13-correct.357527ad.wav";